import { Intent } from '@blueprintjs/core/lib/esm/index';
import React, {PureComponent} from 'react';

import { Classes, Overlay, Collapse, Button, MenuItem, Callout } from "@blueprintjs/core";

export default class PayPhoneNumbersResultModal extends PureComponent{
    state={
        overlayIsOpen: false
    }
    handleClose = () => {
        this.setState({
            overlayIsOpen: false,
        })
    }

    componentDidMount(){
        this.setState({
            overlayIsOpen: this.props.showModal
        })
    }
    componentDidUpdate(){
    }

    handleNext = async () =>{
    }

    handleSubmit = async () => {


        // console.log('Evo me 1: ', anyErrorActive, this.state.errorsList)
        // await this.setState({fieldsCheckActive: false})
    }

    render(){

        return(
            <Overlay
                // onClose={this.props.handleClose}
                className={this.state.billingDetailsOpen ? (Classes.OVERLAY_SCROLL_CONTAINER + ' padding-top-400') : Classes.OVERLAY_SCROLL_CONTAINER}
                // isOpen={this.state.overlayIsOpen}
                isOpen={this.props.showModal}
            >
                <div className="modal-field-payment" style={{width: this.props.width || '60%', maxWidth: this.props.maxWidth || '100%'}}>
                    <div className="add-payment-method-modal-container">
                        <div className='modal-title'>
                            <p className="modal-close-button" onClick={ this.props.handleClose }><i className="fas fa-times"></i></p>
                            <h2>PHONE NUMBERS RESULT</h2>
                        </div>
                        <div className='modal-main'>
                            <div className='margin-top-20 margin-bottom-10'>

                            </div>
                            {this.props.boughtNumbers && this.props.boughtNumbers.length ? <Callout intent={Intent.SUCCESS}>
                                    Successfully bought numbers: <br/>
                                    {this.props.boughtNumbers.map(item => <span>{item.phoneNumber}<br/></span>)}
                                </Callout>
                                :
                                ''
                            }
                            {this.props.notBoughtNumbers && this.props.notBoughtNumbers.length ?
                                <Callout intent={Intent.DANGER}>
                                    Not bought numbers: <br/>
                                    {this.props.notBoughtNumbers.map(item => <span>{item.phoneNumber}<br/></span>)}
                                </Callout>
                                :
                                ''
                            }
                            {this.props.notBoughtNumbers && this.props.notBoughtNumbers.length ?
                                <p className='not-bought-numbers'>Some of the numbers weren't bought. You can try with another payment method or select different phone numbers.</p>
                                :
                                ''
                            }

                            <div className='flex-end'>
                                <button className='btn-transparent-border margin-right-20 margin-bottom-30 margin-top-10' onClick={this.props.handleBackToNumbers}>Back To Numbers Selection</button>
                                { this.props.notBoughtNumbers && this.props.notBoughtNumbers.length ?
                                    <button className='btn-transparent-border margin-right-20 margin-bottom-30 margin-top-10' onClick={ this.props.handleClose }>Pay With Different Card</button>
                                    :
                                    ''
                                }
                                {this.state.loader ?
                                    <button className='btn-action btn-spinner margin-bottom-30 margin-top-10' disabled={true}>Finish  <i className='fa fa-spin fa-spinner'></i></button>
                                    :
                                    <button className='btn-action margin-bottom-30 margin-top-10' onClick={()=>{
                                        this.props.handleClose();
                                        this.props.history.push('/channels')
                                    }}>Finish</button>
                                }
                            </div>
                        </div>
                    </div>

                </div>
            </Overlay>
        )
    }
}